import { render, staticRenderFns } from "./PersonalInformationCard.vue?vue&type=template&id=4acc105b"
import script from "./PersonalInformationCard.vue?vue&type=script&lang=js"
export * from "./PersonalInformationCard.vue?vue&type=script&lang=js"
import style0 from "./PersonalInformationCard.vue?vue&type=style&index=0&id=4acc105b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports